module.exports = __webpack_public_path__ + "img/img6.9d256b9f.png";